export default "__VITE_ASSET__BYO6OIJo__"